export default "__VITE_ASSET__DnuOfl84__"